unit PrjFormPDFDisplay;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  PrjFormDefault,
  VCL.TMSFNCTypes,
  VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics,
  VCL.TMSFNCGraphicsTypes,
  Vcl.Imaging.GIFImg,
  VCL.TMSFNCCustomComponent,
  VCL.TMSFNCStateManager, VCL.TMSFNCResponsiveManager, VCL.TMSFNCTrackBar,
  VCL.TMSFNCSpinEdit, Vcl.Graphics, Vcl.StdCtrls, VCL.TMSFNCButton, Vcl.Controls, WEBLib.StdCtrls, VCL.TMSFNCCustomControl, VCL.TMSFNCPanel,
  VCL.TMSFNCWebBrowser, VCL.TMSFNCCustomWEBControl, VCL.TMSFNCWXPDFViewer, VCL.TMSFNCWXPDFThumbnailList, VCL.TMSFNCCustomScrollControl,
  VCL.TMSFNCCustomList, VCL.TMSFNCWXPDFToolbar, VCL.TMSFNCPDFLib, PrjClassHBMDataAccess, VCL.TMSFNCSplitter, Vcl.Imaging.pngimage,
  WEBLib.ExtCtrls, WEBLib.Buttons, WEBLib.WebCtrls;

type
  TPrjFormsPDFDisplay = class(TPrjFormsDefault)
    pnLeftNavigation: TPanel;
    btnClose: TButton;
    WebBrowserControl1: TBrowserControl;
    procedure btnCloseClick(Sender: TObject);
  private
    { Private-Deklarationen }
  public
    ParameterStr : string;

    [Async]
    function Init: Boolean; async; virtual;
    { Public-Deklarationen }
  protected procedure LoadDFMValues; override; end;

var
  PrjFormsPDFDisplay: TPrjFormsPDFDisplay;

implementation

{$R *.dfm}

uses
  wxBaseClassWebTools;


procedure TPrjFormsPDFDisplay.btnCloseClick(Sender: TObject);
begin
  close;
end;

function TPrjFormsPDFDisplay.Init: Boolean;
begin
  if ParameterStr <> '' then
  begin
//    WaitMessage.Show;
    wxBaseWriteLog.Write('TPrjFormsPDFDisplay.Init = ' + ParameterStr, slDebug);
//    TMSFNCWXPDFViewer1.LoadFromUrl(ParameterStr);
    WebBrowserControl1.URL := ParameterStr
  end;
end;

procedure TPrjFormsPDFDisplay.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnLeftNavigation := TPanel.Create('PanelNAVDefault');
  btnClose := TButton.Create('btnNAVPdfBack');
  WebBrowserControl1 := TBrowserControl.Create(Self);

  WaitMessage.BeforeLoadDFMValues;
  pnLeftNavigation.BeforeLoadDFMValues;
  btnClose.BeforeLoadDFMValues;
  WebBrowserControl1.BeforeLoadDFMValues;
  try
    Width := 1635;
    Height := 959;
    WaitMessage.Picture.LoadFromFile('PrjFormPDFDisplay.WaitMessage.Picture.gif');
    pnLeftNavigation.SetParentComponent(Self);
    pnLeftNavigation.Name := 'pnLeftNavigation';
    pnLeftNavigation.Left := 320;
    pnLeftNavigation.Top := 48;
    pnLeftNavigation.Width := 801;
    pnLeftNavigation.Height := 65;
    pnLeftNavigation.ElementClassName := 'card';
    pnLeftNavigation.HeightStyle := ssAuto;
    pnLeftNavigation.WidthStyle := ssAuto;
    pnLeftNavigation.Alignment := taLeftJustify;
    pnLeftNavigation.Caption := 'pnLeftNavigation';
    pnLeftNavigation.ChildOrder := 2;
    pnLeftNavigation.ElementBodyClassName := 'card-body';
    pnLeftNavigation.ElementFont := efCSS;
    pnLeftNavigation.ElementPosition := epRelative;
    pnLeftNavigation.ShowCaption := False;
    pnLeftNavigation.TabOrder := 1;
    btnClose.SetParentComponent(pnLeftNavigation);
    btnClose.Name := 'btnClose';
    btnClose.Left := 529;
    btnClose.Top := 18;
    btnClose.Width := 176;
    btnClose.Height := 30;
    btnClose.Caption := 'Zur'#252'ck';
    btnClose.ChildOrder := 7;
    btnClose.ElementClassName := 'btn btn-outline';
    btnClose.ElementFont := efCSS;
    btnClose.ElementPosition := epRelative;
    btnClose.HeightStyle := ssAuto;
    btnClose.HeightPercent := 100.00000000000000000;
    btnClose.WidthStyle := ssAuto;
    btnClose.WidthPercent := 100.00000000000000000;
    SetEvent(btnClose, Self, 'OnClick', 'btnCloseClick');
    WebBrowserControl1.SetParentComponent(Self);
    WebBrowserControl1.Name := 'WebBrowserControl1';
    WebBrowserControl1.Left := 128;
    WebBrowserControl1.Top := 168;
    WebBrowserControl1.Width := 1369;
    WebBrowserControl1.Height := 641;
    WebBrowserControl1.ChildOrder := 2;
    WebBrowserControl1.Sandbox := [];
  finally
    WaitMessage.AfterLoadDFMValues;
    pnLeftNavigation.AfterLoadDFMValues;
    btnClose.AfterLoadDFMValues;
    WebBrowserControl1.AfterLoadDFMValues;
  end;
end;

end.



